window.getQueryString = -> $.url().data.param.query

window.queryParamPresent = (param) ->
  if getQueryString()[param] isnt undefined
     _.isString(getQueryString()[param])
  else
    return false

stripSecurityParam = ->
  if queryParamPresent("sa") and location.pathname.indexOf('secure') is -1
    trackEvent("Login")
    query = getQueryString()
    delete query.sa
    newQuery = "?" + $.param(query)
    newHref = if newQuery.length > 1 then location.pathname + newQuery else location.pathname
    history.replaceState({},"foo",newHref)

  if queryParamPresent("sb") and location.pathname.indexOf('secure') is -1
    query = getQueryString()
    delete query.sb
    newQuery = "?" + $.param(query)
    newHref = if newQuery.length > 1 then location.pathname + newQuery else location.pathname
    history.replaceState({},"foo",newHref)

firefoxVersion = (userAgent) ->
  if userAgent.indexOf("Firefox") isnt -1
    firefoxString = userAgent.substr(userAgent.indexOf("Firefox"))
    splits = firefoxString.split("/")
    version = splits[1]
    parseFloat(version) if version

nextPathName = (redirect, search, userAgent) ->
  if (firefoxVersion(userAgent) and firefoxVersion(userAgent) < 52)
    "/#{redirect}/#{search}"
  else
    "/#{redirect}/"

$(document).on "ready page:load", ->
  stripSecurityParam()
  if (queryParamPresent("redirect"))
    if (currentUser().role is "owner" or currentUser().role is "admin" or
        currentUser().role is "affiliate" or currentUser().role is "author")
      return window.location.pathname = nextPathName(getQueryString().redirect, location.search, navigator.userAgent)

window.redirects = {
  nextPathName: nextPathName
  firefoxVersion: firefoxVersion
}
